import { render, staticRenderFns } from "./FeedbackButton.vue?vue&type=template&id=283b3d26&scoped=true"
import script from "./FeedbackButton.vue?vue&type=script&lang=js"
export * from "./FeedbackButton.vue?vue&type=script&lang=js"
import style0 from "./FeedbackButton.vue?vue&type=style&index=0&id=283b3d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283b3d26",
  null
  
)

export default component.exports